import { useRouter } from 'vue-router/composables'
import { getCurrentInstance } from 'vue'
import { useRouterSystem } from '../../../hooks/index'
export function useRouterPush() {
  const router = useRouter()
  const { proxy } = getCurrentInstance()
  const { toSystemOrOrerDetail } = useRouterSystem()
  return {
    router: ({ property, parameter }) => {
      const { ifSystem, ...route } = property
      if (ifSystem && parameter.itemData) {
        const ssoToken = proxy.$SsoRequest.getToken(proxy.$SsoRequest)
        toSystemOrOrerDetail(ssoToken, parameter.itemData, property.processKey)
      } else if (!route.name && !route.path) {
        return Promise.reject('请配置跳转的路由地址！')
      } else {
        router.push({ ...route, query: parameter })
      }
    },
    closeCurrentTabAndRouter: ({ property, parameter }) => {
      if (!property.name && !property.path) {
        return Promise.reject('请配置跳转的路由地址！')
      } else {
        const item = proxy.$store.state.menuStore.currentRouter
        const closename = item.id
        proxy.$store.commit('closeTabByname', {
          id: closename,
          vm: proxy,
        })
        router.push({ ...property, query: parameter })
      }
    },
  }
}
